import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface DetailRowProps {
  label: string;
  value: string | number | null | undefined;
}

function DetailRow({ label, value }: DetailRowProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: 2,
        py: 1,
        borderBottom: 1,
        borderColor: 'divider',
        '&:last-of-type': {
          borderBottom: 0,
        },
      }}
    >
      <Typography variant="body1" component="dt" color="text.secondary" sx={{ fontWeight: 700 }}>
        {label}
      </Typography>

      <Typography
        variant="body1"
        component="dd"
        sx={{
          m: 0,
          textAlign: 'right',
          fontWeight: 700,
          color: 'primary.main',
          overflowWrap: 'anywhere',
        }}
      >
        {value || 'Not recorded'}
      </Typography>
    </Box>
  );
}

export default DetailRow;
